import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import AddIcon from '@mui/icons-material/Add';
import TableCell from 'components/TableCell';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Dialog from 'components/Dialog';
import RateEditor from 'components/RoomRatesTableRateEditor';
import RoomRatesTableRateCellValue from 'components/RoomRatesTableRateCellValue';

import { RoomRatesTableRateCell_rateByRoom$key } from '__generated__/RoomRatesTableRateCell_rateByRoom.graphql';
import { RoomRatesTableRateCell_package$key } from '__generated__/RoomRatesTableRateCell_package.graphql';
import { RoomRatesTableRateCell_packageDate$key } from '__generated__/RoomRatesTableRateCell_packageDate.graphql';
import { RoomRatesTableRateCell_cateringOption$key } from '__generated__/RoomRatesTableRateCell_cateringOption.graphql';
import { RoomRatesTableRateCell_data$key } from '__generated__/RoomRatesTableRateCell_data.graphql';

type Props = {
  data: RoomRatesTableRateCell_data$key;
  rateByRoom: RoomRatesTableRateCell_rateByRoom$key;
  package: RoomRatesTableRateCell_package$key;
  packageDate: RoomRatesTableRateCell_packageDate$key;
  cateringOption: RoomRatesTableRateCell_cateringOption$key;
};

const RoomRatesTableRateCell: FC<Props> = props => {
  const data = useFragment(
    graphql`
      fragment RoomRatesTableRateCell_data on Query {
        ...RoomRatesTableRateEditor_data
      }
    `,
    props.data
  );

  const rateByRoom = useFragment(
    graphql`
      fragment RoomRatesTableRateCell_rateByRoom on RateByRoom {
        __id

        room {
          id
        }

        roomRate {
          ...RoomRatesTableRateCellValue_roomRate
        }

        ...RoomRatesTableRateEditor_rateByRoom
      }
    `,
    props.rateByRoom
  );

  const pack = useFragment(
    graphql`
      fragment RoomRatesTableRateCell_package on Package {
        ...RoomRatesTableRateEditor_package
      }
    `,
    props.package
  );

  const packageDate = useFragment(
    graphql`
      fragment RoomRatesTableRateCell_packageDate on PackageDate {
        id

        ...RoomRatesTableRateEditor_packageDate
      }
    `,
    props.packageDate
  );

  const cateringOption = useFragment(
    graphql`
      fragment RoomRatesTableRateCell_cateringOption on CateringOption {
        id

        ...RoomRatesTableRateEditor_cateringOption
      }
    `,
    props.cateringOption
  );

  return (
    <TableCell center>
      <Dialog
        fullWidth
        modal={false}
        maxWidth="sm"
        activateButton={open =>
          rateByRoom.roomRate ? (
            <Box sx={{ cursor: 'pointer' }} onClick={open}>
              <RoomRatesTableRateCellValue roomRate={rateByRoom.roomRate} />
            </Box>
          ) : (
            <IconButton size="small" onClick={open}>
              <AddIcon fontSize="small" />
            </IconButton>
          )
        }>
        <RateEditor
          data={data}
          rateByRoom={rateByRoom}
          package={pack}
          packageDate={packageDate}
          cateringOption={cateringOption}
        />
      </Dialog>
    </TableCell>
  );
};

export default RoomRatesTableRateCell;
